<template>
  <dv-scroll-board :config="config" style="width:100%;height:100%;" />
</template>

<script>
//专区排行
export default {
  name: "ZGaConsumption",
  data() {
    return {
      config: {},
    }
  },
  methods:{

  },
  created() {
    let user_id = window.localStorage.getItem('user_id');

    const data = {
      'user_id': user_id
    };
    this.$api.zga_real_order(data).then(res=>
    {

      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1; // 月份从0开始，需要加1
      const day = currentDate.getDate();
      let nowday=year + "-" + month + "-" + day;

      var today = new Date();
      var previousDate = new Date(today.getTime() - 24 * 60 * 60 * 1000);
    
      var year2 = previousDate.getFullYear();
      var month2 = previousDate.getMonth() + 1;
      var day2 = previousDate.getDate();
    
      let yestnowday= year2 + '-' + month2 + '-' + day2;




      var tempdata=[];
      tempdata[0]=['正新鸡排',15,0.45,nowday];
      tempdata[1]=['蜜雪冰城',15,0.45,nowday];
      tempdata[2]=['书亦烧仙草',15,0.45,nowday];
      tempdata[3]=['张亮麻辣烫',10,0.3,nowday];
      tempdata[4]=['杨国福麻辣烫',9,0.27,nowday];
      tempdata[5]=['阿利茄汁面',10,0.3,yestnowday];
      tempdata[6]=['蜀香阁火锅',59,1.77,yestnowday];
      tempdata[7]=['田园春饼私房菜',109,3.27,yestnowday];
      tempdata[8]=['小龙坎老火锅',245,7.35,yestnowday];
      tempdata[9]=['杨国福麻辣烫',35,1.05,yestnowday];
 
      let data=[];
      for(let i=0;i<10;i++){
        if(i>=tempdata.length){
          continue;
        }else{
          res[i].splice(4, 1);
          res[i][1]=tempdata[i][0];
          res[i][2]=tempdata[i][1];
          res[i][3]=tempdata[i][2];
          res[i][4]=tempdata[i][3];
        }   
      }

      res=res.splice(0, 10)


      // console.log(res);
      this.config = {
        header: ['订单编号', '门店名称', '购买金额', '让利金额', '购买时间'],
        rowNum:[5],
        data: res,
        headerBGC: '#0081EE',
        oddRowBGC: '#0e0e26',
        evenRowBGC: '#0e0e26',
        index: true,
        columnWidth: [50,350,300,300,200,200],
        align: ['center']
      }
    })


  },

  watch: {

  }
}
</script>

<style scoped>
.galleries {
  width: 100%;
  height: 100%;
}
</style>